import React, { useEffect, useState } from 'react';
import { Box, Button, Text, Flex, Stack } from '@chakra-ui/react';
import Cookies from 'js-cookie';
import { useTranslation } from 'react-i18next';

const CookieConsent = () => {
  const { t } = useTranslation();
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    const consent = Cookies.get('cookie_consent');
    if (!consent) {
      setShowBanner(true);
    }
  }, []);

  const handleAccept = () => {
    Cookies.set('cookie_consent', 'true', { expires: 365 });
    setShowBanner(false);
  };

  const handleDecline = () => {
    setShowBanner(false);
  };

  if (!showBanner) {
    return null;
  }

  return (
    <Box position="fixed" bottom="0" width="100%" bg="gray.700" p={4} color="white" zIndex="100000">
      <Flex align="center" justify="space-between" flexDirection={{ base: 'column', md: 'row' }} textAlign={{ base: 'center', md: 'left' }}>
        <Text mb={{ base: 4, md: 0 }}>
          {t('cookie_consent.text')}
        </Text>
        <Stack direction={{ base: 'column', md: 'row' }} spacing={2}>
          <Button bg="green.500" color="white" onClick={handleAccept} _hover={{ bg: 'green.400' }}>
            {t('cookie_consent.accept')}
          </Button>
          <Button bg="red.500" color="white" onClick={handleDecline} _hover={{ bg: 'red.400' }}>
            {t('cookie_consent.decline')}
          </Button>
        </Stack>
      </Flex>
    </Box>
  );
};

export default CookieConsent;
